import { render, staticRenderFns } from "./caigouForm.vue?vue&type=template&id=7ac6820f&scoped=true&"
import script from "./caigouForm.vue?vue&type=script&lang=js&"
export * from "./caigouForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac6820f",
  null
  
)

export default component.exports